import apiClient from "./apiClient";

const capabilities = [
  { iconName: 'FaUsers', text: 'Expert Developers' },
  { iconName: 'FaRupeeSign', text: 'Affordable Pricing' },
  { iconName: 'FaRocket', text: 'Agile Delivery' },
  { iconName: 'FaHeadset', text: '24/7 Support' },
  { iconName: 'FaGlobe', text: 'Global Client Base' },
  { iconName: 'FaLayerGroup', text: 'Scalable Architecture' },
  { iconName: 'FaShieldAlt', text: 'Secure Applications' },
  { iconName: 'FaChartLine', text: 'Business Growth' },
  { iconName: 'FaLightbulb', text: 'Innovative Ideas' },
  { iconName: 'FaThumbsUp', text: 'Client Satisfaction' },
];


export const getCapabilities = async () => {
  try {
    const response = await apiClient.get("/capabilities");
    return response.data;
  } catch (error) {
      console.error("Error fetching capabilities:", error);
      //throw error; // rethrow so component can handle it
      return capabilities;
  }
};
